import { Button } from "antd"
import RecurrencyModal from "./components/RecurrencyModal/RecurrencyModal"
import EditIcon from '@assets/icons/EditIcon'
import './styles.css'
import { useRecurrencyOption } from "./hooks/useRecurrencyOption"

const RecurrencyOption = () => {
  const { readRecurrenceOptions, isOpenModal, chargeDetail, frecuencyRecurrencyOptions, buttonsOptions, handleOpenCloseModal } = useRecurrencyOption()

  return (
    <div className="recurrency-options">
      <div>
        <strong>Recurrencia de cobro</strong>
        {!chargeDetail.recurrence.metadata ? <p>Aún no se ha definido recurrencia</p>
          : <div className="recurrency-options-body">
            {
              chargeDetail.recurrence.columns.map((item) => (
                <div key={item.key}>
                  <span>{item.title}</span>
                  <p>
                    {
                      item.key === 'frequency_type' ?
                        frecuencyRecurrencyOptions.find((item) => item.id === readRecurrenceOptions['frequency_type'])?.name ??
                        buttonsOptions.find((item) => item.id === readRecurrenceOptions['frequency_type'])?.name
                        :
                        readRecurrenceOptions[item.key]
                    }
                    {
                      item.key === 'issue_date' && ' de todos los meses'
                    }
                    {
                      item.key === 'due_date' && ' días después del día de emisión'
                    }
                  </p>
                </div>
              ))
            }
          </div>}
      </div>
      {
        !chargeDetail.recurrence.metadata ? <Button onClick={() => handleOpenCloseModal({ isOpenModal: true })} className="btn-standard-white" shape="round" style={{ width: '92px' }}>
          DEFINIR
        </Button> :
          <Button
            onClick={() => handleOpenCloseModal({ isOpenModal: true })}
            className="btn-standard-transparent"
            style={{ width: '40px', height: '40px', border: '1px solid #232C4A', borderRadius: '50%' }}
            icon={<EditIcon color="#232C4A" width="20px" height="20px" />}
          />}
      <RecurrencyModal
        isOpenModal={isOpenModal}
        handleOpenCloseModal={handleOpenCloseModal}
      />
    </div>
  )
}

export default RecurrencyOption
